<div class="not-found" *ngIf="notFoundMessage">{{notFoundMessage}}</div>

<mat-card [style]="getTableStyle()">
  <mat-table [dataSource]="dataSource" matSort matSortActive="inceptionDate" matSortDirection="asc" matSortDisableClear>
    <ng-container matColumnDef="claimType">
      <mat-header-cell *matHeaderCellDef> Claim Type </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <div class="ellipsis" matTooltip={{row.claimType}}> {{row.claimType}}</div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="claimDate">
      <mat-header-cell *matHeaderCellDef> Claim Date </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <div class="ellipsis"> {{row.claimDate| date: appConstants.dateConfig.date}}</div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="paidValue">
      <mat-header-cell *matHeaderCellDef> Paid Value (Excluding VAT) </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <div class="ellipsis"> {{row.paidValue | currency:'GBP':'symbol'}}</div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="claimAcceptedDate">
      <mat-header-cell *matHeaderCellDef> Claim Accepted Date </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <div class="ellipsis">{{row.claimAcceptedDate | date: appConstants.dateConfig.date}}</div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="serviceProvider">
      <mat-header-cell *matHeaderCellDef> Service Provider </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <div class="ellipsis" matTooltip={{row.serviceProvider}}>{{row.serviceProvider}}</div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="rejectionReason">
      <mat-header-cell *matHeaderCellDef> Rejection Reason </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <div class="ellipsis" matTooltip={{row.rejectionReason}}>{{row.rejectionReason}}</div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="rejectionDate">
      <mat-header-cell *matHeaderCellDef> Rejection Date </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <div class="ellipsis" >{{row.rejectionDate | date: appConstants.dateConfig.date}}</div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="product">
      <mat-header-cell *matHeaderCellDef> Product </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <div class="ellipsis" matTooltip={{row.product}}>{{row.product}}</div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="subProduct">
      <mat-header-cell *matHeaderCellDef> Sub Product</mat-header-cell>
      <mat-cell *matCellDef="let row">
        <div class="ellipsis" matTooltip={{row.subProduct}}>{{row.subProduct}}</div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="brokerBranchName">
      <mat-header-cell *matHeaderCellDef> Broker Branch Name </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <div class="ellipsis" matTooltip={{row.brokerBranchName}}>{{row.brokerBranchName}}</div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="inceptionDate">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Policy Inception Date </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <div class="ellipsis">{{row.inceptionDate |date: appConstants.dateConfig.date}}</div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="certificateNumber">
      <mat-header-cell *matHeaderCellDef> Certificate Number </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <div class="ellipsis" matTooltip={{row.certificateNumber}}>{{row.certificateNumber}}</div>
      </mat-cell>
    </ng-container>


    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row matRipple *matRowDef="let row; columns: displayedColumns;"></mat-row>
  </mat-table>
  <div class="display-flex flex-direction-row footer">
    <div class="btn-group flex-50">
      <button class="btnExport" [disabled]="!(dataSource && dataSource.data && dataSource.data.length> 0)"
        matTooltip="Export to Excel" mat-raised-button color="primary" (click)="exportExcel()">
        Export to Excel
      </button>
      <button class="btnExport" [disabled]="!(dataSource && dataSource.data && dataSource.data.length> 0)"
        matTooltip="Export to CSV" mat-raised-button color="primary" (click)="exportCsv()">
        Export to CSV
      </button>
      <button class="btnExport" [disabled]="!(dataSource && dataSource.data && dataSource.data.length> 0)"
        matTooltip="Export to PDF" mat-raised-button color="primary" (click)="exportPdf()">
        Export to PDF
      </button>
    </div>

    <div class="paging flex-50">
      <mat-paginator [length]="totalRows" [pageIndex]="pagingConstant.pageIndex"
        [pageSize]="pagingConstant.pageSizeLarger" [pageSizeOptions]="pagingConstant.pageSizeOptionsLarger"
        showFirstLastButtons>
      </mat-paginator>
    </div>
  </div>
</mat-card>
